angular.module('impactx.dashboard')
    .directive('ixDashboardPanel', function() {
        return {
            scope: {
                width: "<",
                height: "<",
                template: "@",
                isHidden: "=",
                element: "<",
                fullWidth: "<",
                scroll: "<"
            },
            name: 'ctrl',
            controller: '@',
            controllerAs: 'panelCtrl',
            restrict: 'E',
            templateUrl: 'modules/dashboard/templates/dashboard.panel.tmpl.html'
        };
    });